import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Positions.scss';
import Position from './Position';

// @injectIntl
export default class Positions extends Component {
    static propTypes = {
        positions: PropTypes.any,
    }

    render() {
        const { positions, ...props } = this.props;

        const sortedPositions = positions
            .sortBy(pos => pos.get('sorting'))
            .filter(pos => pos.get('active'));

        const list = sortedPositions
            .map(pos => <Position key={pos.get('id')} position={pos} {...props} />)
            .toArray();

        return (
            <div className={styles.positions}>{list}</div>
        );
    }
}
